module.exports = __webpack_public_path__ + "static/circle-grocers-68903b6ac1207f0dbea21fca2446f990.png";